import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 默认数据
var defaultData = {
  userInfo: {
    nick_name: null, // 昵称
    head_img: null, // 头像
    is_site_admin: 1, // 是否是站点管理员
    staff_type: 0, // 账号类型 0：应用账号 1：总账户
    applyId: 0, // 应用ID
    toRoute: null // 默认跳转路由
  },
  applyInfo: {
    apply_id: null, // 应用ID
    apply_logo: null, // 应用Logo
    expire_time: null, // 到期时间
    is_permanent: 0, // 是否永久授权
    plugin_id: [] // 已安装的插件ID数组
  },
  // 企业信息
  insInfo: {
    id: null, // 企业ID
    name: null // 企业名称
  },
  // 选中场景ID
  selectedSceneId: null
}

const store = new Vuex.Store({
  state: {
    labelType: 2, // 标签页所在标记 1：站点路由 0：应用路由
    isSiteToApply: 0, // 是否是站点路由到应用路由
    // 登录账号信息，只包含 站点账号、应用账号
    userInfo: defaultData.userInfo,
    // 登录应用信息
    applyInfo: defaultData.applyInfo,
    showSubMenu: false, // 是否显示应用子菜单
    subMenuItems: [], // 应用子菜单信息
    topPlugin: [], // 置顶应用插件信息
    isShowHead: true, // 是否显示头部和路由菜单
    // 企业信息
    insInfo: defaultData.insInfo,
    // 选中场景ID
    selectedSceneId: defaultData.selectedSceneId,
    // 消息中心未读数
    messageUnreadCount: 0
  },
  mutations: {
    INCREMENT_MESSAGE_UNREAD (state) {
      state.messageUnreadCount = (state.messageUnreadCount || 0) + 1
    },
    SET_MESSAGE_UNREAD (state, count) {
      state.messageUnreadCount = count
    },
    // 修改标签页状态
    UPDATE_TYPE (state, res) {
      state.labelType = res
    },
    // 修改登录用户信息（只包含站点账号以及应用账号）
    UPDATE_USER_INFO (state, res) {
      state.userInfo = res
    },
    // 重置用户登录信息
    RESET_USER_INFO (state) {
      state.userInfo = defaultData.userInfo
    },
    // 重置应用信息
    RESET_APPLY_INFO (state) {
      state.applyInfo = defaultData.applyInfo
    },
    // 设置应用信息
    SET_APPLY_INFO (state, res) {
      state.applyInfo = res
    },
    // 设置应用子菜单
    SET_SUB_MENU (state, res) {
      state.subMenuItems = res
    },
    // 设置是否显示应用子菜单
    SET_SHOW_SUB_MENU (state, res) {
      state.showSubMenu = res
    },
    // 添加置顶应用插件
    ADD_TOP_PLUGIN (state, res) {
      state.topPlugin.push(res)
    },
    // 设置置顶应用插件
    SET_TOP_PLUGIN (state, res) {
      state.topPlugin = res
    },
    // 清空置顶应用插件
    CLEAR_TOP_PLUGIN (state) {
      state.topPlugin = []
    },
    // 设置企业信息
    SET_INS_INFO (state, res) {
      state.insInfo = res
    },
    // 设置选中场景ID
    SET_SELECTED_SCENE_ID (state, res) {
      state.selectedSceneId = res
    },
    SET_IS_SHOW_HEAD (state, res) {
      state.isShowHead = res
    }
  },
  getters: {
    // 获取用户唯一标识，用于生成 localStorage key
    getUserTopPluginKey: (state) => {
      const userInfo = state.userInfo || {}
      const applyInfo = state.applyInfo || {}
      // 使用 applyId + staff_type + phone(或其他唯一标识) 作为key
      // 优先使用 phone，如果没有则使用 id，再没有则使用 nick_name
      const userId = userInfo.phone || userInfo.id || userInfo.nick_name
      const applyId = applyInfo.apply_id
      const staffType = userInfo.staff_type

      // 如果关键信息缺失，返回 null（调用方需要处理）
      if (!userId || !applyId || staffType === undefined) {
        return null
      }

      return `TOP_PLUGIN_${applyId}_${staffType}_${userId}`
    }
  },
  actions: {
    // 更新应用信息
    updateApplyInfo ({
      commit,
      dispatch,
      state
    }, {
      applyInfo
    }) {
      localStorage.setItem('APPLY_INFO', JSON.stringify(applyInfo))
      commit('SET_APPLY_INFO', applyInfo)
      // 更新应用信息后，只有在应用路由（labelType === 0）时才恢复置顶插件
      // 如果当前是站点路由（labelType === 1）或机构路由（labelType === 2），不应该恢复置顶插件
      if (state.labelType === 0 && state.userInfo && (state.userInfo.phone || state.userInfo.id || state.userInfo.nick_name) && applyInfo.apply_id) {
        // 使用 setTimeout 确保 state 已更新
        setTimeout(() => {
          dispatch('restoreTopPlugin')
        }, 0)
      } else if (state.labelType === 1 || state.labelType === 2) {
        // 如果是站点路由或机构路由，清空内存中的置顶插件
        commit('CLEAR_TOP_PLUGIN')
      }
    },
    // 更新用户信息
    updateUserInfo ({
      commit,
      dispatch,
      state
    }, userInfo) {
      // 用户信息存储
      localStorage.setItem('USER_INFO', JSON.stringify(userInfo))
      commit('UPDATE_USER_INFO', userInfo)
      // 如果应用信息已存在，恢复置顶插件（用户信息更新后）
      if (state.applyInfo && state.applyInfo.apply_id && (userInfo.phone || userInfo.id || userInfo.nick_name)) {
        setTimeout(() => {
          dispatch('restoreTopPlugin')
        }, 0)
      }
    },
    // 更新标签信息
    updateLabelType ({
      commit
    }, labelType) {
      // 标签页标记存储
      localStorage.setItem('LABEL_TYPE', labelType)
      commit('UPDATE_TYPE', labelType)
    },
    // 清空用户信息
    reomveUserInfo ({
      commit,
      dispatch
    }) {
      // 不清空 localStorage 中的置顶插件，保留以便下次登录时恢复
      // 因为 key 是按 applyId + staffType + userId 生成的，不同账号的 key 不同，不会互相影响
      localStorage.removeItem('APPLY_MENU') // 清空应用路由
      localStorage.removeItem('USER_INFO') // 清空用户登录信息
      localStorage.removeItem('SITE_SELECTED_MENU') // 清空站点选中菜单
      localStorage.removeItem('INS_INFO') // 清空企业信息
      localStorage.removeItem('ACCESS_TOKEN') // 清空登录token
      localStorage.removeItem('site_active_name') // 清空站点选中菜单
      localStorage.removeItem('site_open_names') // 清空站点二级打开菜单
      localStorage.removeItem('institution_active_name') // 清空企业选中菜单
      localStorage.removeItem('institution_open_names') // 清空企业二级打开菜单
      localStorage.removeItem('APPLY_INFO') // 清空应用信息
      commit('RESET_USER_INFO')
      commit('CLEAR_TOP_PLUGIN') // 只清空内存中的置顶插件，不清空 localStorage
    },
    // 清空应用信息
    removeApplyInfo ({
      commit,
      dispatch
    }) {
      // 返回系统时，只清空内存中的置顶插件，不清空 localStorage（保留以便下次进入时恢复）
      dispatch('clearTopPlugin', { clearLocalStorage: false })
      localStorage.removeItem('APPLY_INFO')
      commit('RESET_APPLY_INFO')
      commit('CLEAR_TOP_PLUGIN') // 清空内存中的置顶插件
    },
    // 设置应用子菜单
    setSubMenu ({
      commit
    }, res) {
      localStorage.setItem('SITE_SELECTED_MENU', JSON.stringify(res)) // 缓存选中的菜单信息
      commit('SET_SUB_MENU', res)
    },
    // 设置是否显示应用子菜单
    setShowSubMenu ({
      commit
    }, res) {
      commit('SET_SHOW_SUB_MENU', res)
    },
    // 设置置顶应用插件
    addTopPlugin ({
      commit,
      state,
      getters
    }, res) {
      commit('ADD_TOP_PLUGIN', res)
      // 保存到 localStorage
      const key = getters.getUserTopPluginKey
      if (key) {
        const pluginsToSave = JSON.stringify(state.topPlugin)
        try {
          localStorage.setItem(key, pluginsToSave)
        } catch (e) {
          // localStorage 保存失败，静默处理
        }
      }
    },
    // 设置置顶应用插件
    setTopPlugin ({
      commit,
      state,
      getters
    }, res) {
      commit('SET_TOP_PLUGIN', res)
      // 保存到 localStorage
      const key = getters.getUserTopPluginKey
      if (key) {
        const pluginsToSave = JSON.stringify(state.topPlugin)
        try {
          localStorage.setItem(key, pluginsToSave)
        } catch (e) {
          // localStorage 保存失败，静默处理
        }
      }
    },
    // 清空置顶应用插件
    clearTopPlugin ({
      commit,
      getters,
      state
    }, options = {}) {
      commit('CLEAR_TOP_PLUGIN')
      // 清空 localStorage
      // 如果指定了 clearLocalStorage: false，则不清空 localStorage（只清空内存）
      if (options.clearLocalStorage !== false) {
        const key = getters.getUserTopPluginKey
        if (key) {
          localStorage.removeItem(key)
        } else {
          // 如果无法生成 key，尝试清空所有相关的 keys（用于清理旧数据）
          const allKeys = Object.keys(localStorage).filter(k => k.startsWith('TOP_PLUGIN_'))
          if (allKeys.length > 0 && options.clearAll !== false) {
            allKeys.forEach(k => localStorage.removeItem(k))
          }
        }
      }
    },
    // 从 localStorage 恢复置顶插件
    restoreTopPlugin ({
      commit,
      getters,
      state
    }) {
      const key = getters.getUserTopPluginKey
      if (!key) {
        return // 如果无法生成 key，说明用户信息或应用信息不完整，不恢复
      }

      // 检查所有可能的 key（因为用户标识可能变化）
      const userInfo = state.userInfo || {}
      const applyInfo = state.applyInfo || {}
      const applyId = applyInfo.apply_id
      const staffType = userInfo.staff_type

      // 如果关键信息缺失，直接返回
      if (!applyId || staffType === undefined) {
        return
      }

      // 尝试多个可能的 key
      const possibleKeys = []
      if (userInfo.phone && applyId && staffType !== undefined) {
        possibleKeys.push(`TOP_PLUGIN_${applyId}_${staffType}_${userInfo.phone}`)
      }
      if (userInfo.id && applyId && staffType !== undefined) {
        possibleKeys.push(`TOP_PLUGIN_${applyId}_${staffType}_${userInfo.id}`)
      }
      if (userInfo.nick_name && applyId && staffType !== undefined) {
        possibleKeys.push(`TOP_PLUGIN_${applyId}_${staffType}_${userInfo.nick_name}`)
      }

      let savedPlugins = null
      let foundKey = null

      // 先尝试当前生成的 key
      savedPlugins = localStorage.getItem(key)
      if (savedPlugins) {
        foundKey = key
      } else {
        // 如果当前 key 找不到，尝试其他可能的 key
        for (const possibleKey of possibleKeys) {
          if (possibleKey !== key) {
            const data = localStorage.getItem(possibleKey)
            if (data) {
              savedPlugins = data
              foundKey = possibleKey
              break
            }
          }
        }
      }

      if (savedPlugins) {
        try {
          const plugins = JSON.parse(savedPlugins)
          if (Array.isArray(plugins) && plugins.length > 0) {
            commit('SET_TOP_PLUGIN', plugins)
          } else {
            commit('CLEAR_TOP_PLUGIN')
          }
        } catch (e) {
          commit('CLEAR_TOP_PLUGIN')
        }
      }
    },
    // 设置企业信息
    setInsInfo ({
      commit
    }, res) {
      // 企业信息存储
      localStorage.setItem('INS_INFO', JSON.stringify(res))
      commit('SET_INS_INFO', res)
    },
    // 清空企业信息
    removeInsInfo ({
      commit
    }) {
      localStorage.removeItem('INS_INFO')
      commit('SET_INS_INFO', defaultData.insInfo)
    },
    // 设置选中场景ID
    setSelectedSceneId ({
      commit
    }, res) {
      if (res) {
        // 确保存储为字符串（localStorage只能存储字符串）
        localStorage.setItem('SELECTED_SCENE_ID', String(res))
        // commit时转换为数字，确保类型一致
        commit('SET_SELECTED_SCENE_ID', parseInt(res))
      } else {
        localStorage.removeItem('SELECTED_SCENE_ID')
        commit('SET_SELECTED_SCENE_ID', res)
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js